///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export class E2eTestUtils {
    private static readonly DISABLE_TOOLTIPS_FLAG = 'disableNgxTooltips';

    private static readonly GET_MAP_OBJECT_FLAG = 'getMapObject';
    private static readonly MAP_OBJECT_ATTRIBUTE_NAME = 'googleMapObject';

    private static readonly SHOW_LINE_MARKERS_FLAG = 'showLineMarkers';
    private static readonly SHOW_POLYGON_MARKERS_FLAG = 'showPolygonMarkers';

    private static readonly DISABLE_GEOCODING_FLAG = 'disableGeocoding';

    public static isTooltipsDisabled(): boolean {
        return window[E2eTestUtils.DISABLE_TOOLTIPS_FLAG] !== undefined;
    }

    public static exposeMapObjectToTests(map: google.maps.Map): void {
        if (window[E2eTestUtils.GET_MAP_OBJECT_FLAG]) {
            window[E2eTestUtils.MAP_OBJECT_ATTRIBUTE_NAME] = map;
        }
    }

    public static getShowLineMarkers(): string {
        return window[E2eTestUtils.SHOW_LINE_MARKERS_FLAG];
    }

    public static getShowPolygonMarkers(): string {
        return window[E2eTestUtils.SHOW_POLYGON_MARKERS_FLAG];
    }

    public static isGeocodingEnabled(): boolean {
        return window[E2eTestUtils.DISABLE_GEOCODING_FLAG] === undefined;
    }
}
